import React from "react";


function ZoomIn({ onTransform, disabled }) {

  /**
   * Handles the zoom in functionality when the user clicks the zoom in button.
   * If the button is not disabled, it calls the `onTransform` function with the event, "zoom" as the type, and a zoom factor of 0.1.
   * @param {React.MouseEvent} event - The click event object.
   */
  const zoomObject = (event) => {
    if (!disabled) {
      onTransform( event, "zoom", 0.1 );
    }
  };

  return (
    <div
      className="toolbar-button"
      data-test={"image-zoom-in"}
      onClick={ zoomObject }
      style={disabled ? { opacity: 0.5, cursor: "not-allowed" } : {}}>
      <i className="fas fa-search-plus"></i>
    </div>
  );
}

export default ZoomIn;